/**
 * Returns the name of the key for the first result resolved
 * by the predicate
 *
 * @template T
 * @param {T} obj
 * @param {(item: any) => boolean} predicate
 * @return {*}  {string}
 */
export var findFirstKey = function (obj, predicate) { return Object.keys(obj).find(function (key) { return predicate(obj[key]); }); };
//# sourceMappingURL=findFirstKey.js.map